// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerContent = "footer-module--footer-content--CL5AO";
export var fpLogo = "footer-module--fp-logo--AGx55";
export var staffRow = "footer-module--staff-row--cmXhM";
export var staffMember = "footer-module--staff-member--GNF6s";
export var madeBy = "footer-module--made-by--kKmWN";